import { Divider } from 'antd';

import './VerticalDivider.less';

const VerticalDivider = () => (
  <Divider orientation="vertical" className="__VerticalDivider__" />
);

export default VerticalDivider;
